import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import NumberFlow from '@number-flow/react';

import { DEFAULT_CURRENCY } from 'support/helpers/currency/currency';

export const OrderFormSubtotal = ({
  subtotal,
  currency,
}: {
  subtotal: number;
  currency: string | undefined | null;
}) => {
  const { t } = useTranslation();

  const [hasInitializedSubtotal, setHasInitializedSubtotal] = useState(false);
  useEffect(() => {
    if (!hasInitializedSubtotal) {
      setHasInitializedSubtotal(true);
    }
  }, [hasInitializedSubtotal]);

  return (
    <div className="inline-flex gap-1 text-right align-baseline text-sm text-gray-700">
      <span>{t('orderForms:form.subtotal')}</span>
      <NumberFlow
        value={hasInitializedSubtotal ? subtotal : 0} // hack to avoid slide from the right of the page
        format={{ style: 'currency', currency: currency || DEFAULT_CURRENCY }}
      />
    </div>
  );
};
